var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5826 2.65708C19.3519 1.78691 18.6745 1.10399 17.814 0.872675C16.2541 0.450439 10 0.450439 10 0.450439C10 0.450439 3.74588 0.450439 2.18601 0.872675C1.32552 1.10399 0.648114 1.78691 0.41743 2.65708C0 4.2322 0 7.51462 0 7.51462C0 7.51462 0 10.797 0.41743 12.3722C0.648114 13.2423 1.32552 13.8959 2.18601 14.1272C3.74588 14.5494 10 14.5494 10 14.5494C10 14.5494 16.2541 14.5494 17.814 14.1272C18.6745 13.8959 19.3519 13.2387 19.5826 12.3722C20 10.797 20 7.51462 20 7.51462C20 7.51462 20 4.2322 19.5826 2.65708ZM7.95679 10.496V4.53327L13.182 7.51462L7.95679 10.496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.6f2f93486f7d7afbc775d85f8ca56f0d.svg";
export { ForwardRef as ReactComponent };